import { DataField } from '../DataModels';
import { makeInt64DataField, makeStringDataField } from '../DataFieldHelper';

export namespace Error {
  export interface Contract {
    errorGroup: string;
    tag: number;
    code?: number;
    id?: number;
    count?: number;
  }

  /**
   * Gets data fields for the Error Contract
   * @param instanceName - The instance name of this Error Contract
   * @param contract - The object containing data fields pertaining to the Error Contract
   */
  export function getFields(instanceName: string, contract: Contract): DataField[] {
    let dataFields: DataField[] = [];
    dataFields.push(makeStringDataField(`${instanceName}.ErrorGroup`, contract.errorGroup));
    dataFields.push(makeInt64DataField(`${instanceName}.Tag`, contract.tag));
    if (contract.code !== undefined) {
      dataFields.push(makeInt64DataField(`${instanceName}.Code`, contract.code));
    }
    if (contract.id !== undefined) {
      dataFields.push(makeInt64DataField(`${instanceName}.Id`, contract.id));
    }
    if (contract.count !== undefined) {
      dataFields.push(makeInt64DataField(`${instanceName}.Count`, contract.count));
    }
    return dataFields;
  }
} // Error
